import axios from 'axios';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import React, { Component } from 'react';
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
const urlListaDocentes = ApiUrl + "listusuariosadmdocen" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlAsignaturasDocente = ApiUrl + "listarasigndocenteperiodconheteroeval" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlResultadosEvaluacion = ApiUrl + "resultadosheteroevaldocperiodoasign" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

export default class ResultadosEvaluacionDocente extends Component {
    constructor(props) {
        super(props);
        this.state = {
            docentes: [],
            periodos: [],
            asignaturas: [],
            docenteSeleccionado: '',
            periodoSeleccionado: '',
            asignaturaSeleccionada: '',
            resultadosEvaluacion: [],
            modalResultados: false,
            paginasPreguntas: {},
            promedioGeneral100: null,
            promedioGeneral21: null
        };
    }

    componentDidMount() {
        // Cargar docentes al montar el componente
        axios.get(urlListaDocentes)
            .then(res => {
                this.setState({ docentes: res.data.data });
            })
            .catch(error => {
                console.error("Error al cargar docentes", error);
            });

        // Cargar periodos al montar el componente
        axios.get(urlListPeriodos)
            .then(res => {
                this.setState({ periodos: res.data.data });
            })
            .catch(error => {
                console.error("Error al cargar periodos", error);
            });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    consultarAsignaturas = () => {
        const { docenteSeleccionado, periodoSeleccionado } = this.state;
        if (!docenteSeleccionado || !periodoSeleccionado) {
            swal("Error", "Seleccione un docente y un período", "error");
            return;
        }

        // Limpiar datos anteriores
        this.setState({
            asignaturas: [],
            promedioGeneral100: null,
            promedioGeneral21: null
        });

        axios.post(urlAsignaturasDocente, {
            id_adm: docenteSeleccionado,
            id_periodo: periodoSeleccionado,
        })
            .then(res => {
                const asignaturas = res.data.data;

                let promedioGeneral100 = null;
                let promedioGeneral21 = null;

                const asignaturasConResultado = asignaturas.filter(a => !isNaN(parseFloat(a.resultado_global)));

                if (asignaturasConResultado.length > 0) {
                    const suma = asignaturasConResultado.reduce((acc, a) => acc + parseFloat(a.resultado_global), 0);
                    promedioGeneral100 = parseFloat((suma / asignaturasConResultado.length).toFixed(2));
                    promedioGeneral21 = parseFloat((promedioGeneral100 * 21 / 100).toFixed(2));
                }

                this.setState({
                    asignaturas,
                    promedioGeneral100,
                    promedioGeneral21
                });

                if (asignaturas.length === 0) {
                    swal("Información", "El docente no tiene asignaturas en este período", "info");
                }
            })
            .catch(error => {
                console.error("Error al cargar asignaturas", error);
                swal("Error", "No se pudieron cargar las asignaturas", "error");
            });
    };

    mostrarResultados = (asignatura) => {
        this.setState({ asignaturaSeleccionada: asignatura });

        axios.post(urlResultadosEvaluacion, {
            asignatura_id: asignatura.id_asignatura,
            periodo_id: this.state.periodoSeleccionado,
            docente_id: this.state.docenteSeleccionado,
            paralelo: asignatura.id_paralelo,
        })
            .then(res => {
                if (res.data.success && res.data.data.length > 0) {
                    this.setState({
                        resultadosEvaluacion: res.data.data,
                        mensajeEvaluacion: "",
                        modalResultados: true
                    });
                } else {
                    // Mostrar el mensaje si no hay evaluaciones
                    this.setState({
                        resultadosEvaluacion: [],
                        mensajeEvaluacion: res.data.message || "La asignatura no ha sido evaluada.",
                        modalResultados: true
                    });
                }
            })
            .catch(error => {
                console.error("Error al cargar resultados", error);
                this.setState({
                    resultadosEvaluacion: [],
                    mensajeEvaluacion: "Error al cargar los resultados.",
                    modalResultados: true
                });
            });
    };

    handleCambiarPaginaPregunta = (idPregunta, nuevaPagina) => {
        this.setState(prevState => ({
            paginasPreguntas: {
                ...prevState.paginasPreguntas,
                [idPregunta]: nuevaPagina
            }
        }));
    };

    cerrarModalResultados = () => {
        this.setState({ modalResultados: false });
    };

    // Método para exportar datos a Excel
    exportToExcel = async () => {
        const { asignaturas, docenteSeleccionado, periodoSeleccionado, docentes, periodos } = this.state;

        const docenteObj = docentes.find(d => d.id_administrativo === parseInt(docenteSeleccionado));
        const periodoObj = periodos.find(p => p.id_periodo_academico === parseInt(periodoSeleccionado));

        const nombreDocente = docenteObj
            ? `${docenteObj.apellidos_administrativo} ${docenteObj.nombres_administrativo}`
            : 'No especificado';

        const nombrePeriodo = periodoObj
            ? periodoObj.descripcion_periodo_academico
            : 'No especificado';

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Reporte Docente');

        // Insertar imagen (logo institucional)
        const response = await fetch('/assets/img/logoISTMAS.png');
        const blob = await response.blob();
        const arrayBuffer = await blob.arrayBuffer();
        const imageId = workbook.addImage({
            buffer: new Uint8Array(arrayBuffer),
            extension: 'png'
        });

        worksheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 40 }
        });

        // Título principal
        worksheet.mergeCells('A5:E5');
        worksheet.getCell('A5').value = 'REPORTE DE HETEROEVALUACIÓN DOCENTE POR PERIODO';
        worksheet.getCell('A5').font = { bold: true, size: 14 };
        worksheet.getCell('A5').alignment = { vertical: 'middle', horizontal: 'center' };

        // Datos del docente y período
        worksheet.getCell('A6').value = 'Docente:';
        worksheet.getCell('A6').font = { bold: true };
        worksheet.getCell('B6').value = nombreDocente;

        worksheet.getCell('A7').value = 'Período:';
        worksheet.getCell('A7').font = { bold: true };
        worksheet.getCell('B7').value = nombrePeriodo;

        // Encabezados
        const headers = ['Carrera', 'Asignatura', 'Nivel', 'Paralelo', 'Promedio'];
        worksheet.addRow([]); // Fila 8 vacía
        worksheet.addRow(headers);

        const headerRow = worksheet.getRow(9);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        // Datos
        asignaturas.forEach((a) => {
            const row = worksheet.addRow([
                a.carrera,
                a.asignatura,
                a.nivel,
                a.paralelo,
                a.resultado_global
            ]);
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        const asignaturasConResultado = asignaturas.filter(a => !isNaN(parseFloat(a.resultado_global)));

        let promedio100 = 'N/A';
        let promedio21 = 'N/A';

        if (asignaturasConResultado.length > 0) {
            const suma = asignaturasConResultado.reduce((acc, a) => acc + parseFloat(a.resultado_global), 0);
            promedio100 = (suma / asignaturasConResultado.length).toFixed(2);
            promedio21 = (promedio100 * 21 / 100).toFixed(2);
        }

        // Insertar fila de separación
        worksheet.addRow([]);

        // Fila promedio sobre 100
        const filaProm100 = worksheet.addRow(['', '', '', 'Promedio General /100:', promedio100]);
        filaProm100.eachCell((cell, colNumber) => {
            if (colNumber >= 4) {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center' };
            }
        });

        // Fila promedio sobre 21
        const filaProm21 = worksheet.addRow(['', '', '', 'Promedio General /21:', promedio21]);
        filaProm21.eachCell((cell, colNumber) => {
            if (colNumber >= 4) {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center' };
            }
        });

        // Ajustar tamaño de columnas
        worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const cellLength = cell.value ? cell.value.toString().length : 0;
                if (cellLength > maxLength) {
                    maxLength = cellLength;
                }
            });
            // Limitar ancho mínimo y máximo
            const adjustedWidth = Math.min(Math.max(maxLength + 2, 5), 30);
            column.width = adjustedWidth;
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blobFinal = new Blob([buffer], { type: 'application/octet-stream' });
        saveAs(blobFinal, 'reporte_docentes.xlsx');
    };

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{ }</li>
                </ol>
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="card-header back-istmas">
                        <i className="far fa-sticky-note"></i>
                        <b>-Reporte de Docentes</b>
                    </div>
                    <div className="card-body">
                        <div className="row mt-3">
                            <div className="col-md-4">
                                <label>Docente</label>
                                <select className="form-select" name="docenteSeleccionado" onChange={this.handleChange}>
                                    <option value="">Seleccione un docente</option>
                                    {this.state.docentes
                                        .sort((a, b) => a.apellidos_administrativo.localeCompare(b.apellidos_administrativo))
                                        .map((docente) => (
                                            <option key={docente.id_administrativo} value={docente.id_administrativo}>
                                                {docente.apellidos_administrativo} {docente.nombres_administrativo}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label>Período</label>
                                <select className="form-select" name="periodoSeleccionado" onChange={this.handleChange} disabled={!this.state.docenteSeleccionado}>
                                    <option value="">Seleccione un período</option>
                                    {this.state.periodos.map((periodo) => (
                                        <option key={periodo.id_periodo_academico} value={periodo.id_periodo_academico}>
                                            {periodo.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-4 d-flex align-items-end">
                                <Button color="primary" onClick={this.consultarAsignaturas}>Consultar</Button>
                            </div>
                        </div>
                        {this.state.asignaturas.length > 0 && (
                            <div>
                                <Table className="mt-4" bordered>
                                    <thead>
                                        <tr>
                                            <th>Carrera</th>
                                            <th>Asignatura</th>
                                            <th>Nivel</th>
                                            <th>Paralelo</th>
                                            <th>Promedio</th>
                                            <th>Resultados</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.asignaturas.map((asignatura) => (
                                            <tr key={asignatura.id_asignatura}>
                                                <td>{asignatura.carrera}</td>
                                                <td>{asignatura.asignatura}</td>
                                                <td>{asignatura.nivel}</td>
                                                <td>{asignatura.paralelo}</td>
                                                <td>{asignatura.resultado_global}</td>
                                                <td>
                                                    <Button color="info" onClick={() => this.mostrarResultados(asignatura)}>Ver Resultados</Button>
                                                </td>
                                            </tr>
                                        ))}
                                        {/* Filas resumen */}
                                        <tr>
                                            <td colSpan="4" className="text-end"><strong>Promedio General /100:</strong></td>
                                            <td><strong>{this.state.promedioGeneral100 ?? 'NA'}</strong></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="4" className="text-end"><strong>Promedio General /21:</strong></td>
                                            <td><strong>{this.state.promedioGeneral21 ?? 'NA'}</strong></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <button className="btn btn-success mb-3" onClick={() => this.exportToExcel()}>
                                    Exportar a Excel
                                </button>
                            </div>
                        )}
                        <Modal isOpen={this.state.modalResultados} toggle={this.cerrarModalResultados}>
                            <ModalHeader toggle={this.cerrarModalResultados}>Resultados de Evaluación</ModalHeader>
                            <ModalBody>
                                {this.state.mensajeEvaluacion ? (
                                    <p>{this.state.mensajeEvaluacion}</p>
                                ) : (
                                    this.state.resultadosEvaluacion.length > 0 ? (
                                        <div>
                                            {(() => {
                                                // Inicializar variables para el promedio general
                                                let sumaValoresObtenidos = 0;
                                                let sumaValoresMaximos = 0;

                                                return (
                                                    <>
                                                        {/* Preguntas de opción múltiple */}
                                                        {this.state.resultadosEvaluacion
                                                            .filter(resultado => resultado.tipo === 'Opción Múltiple')
                                                            .map((resultado, index) => {
                                                                const valorMaximo = Number(resultado.valor_maximo || 1);

                                                                const totalRespuestas = resultado.respuestas.reduce((sum, res) => {
                                                                    return sum + Number(res.cantidad || 0);
                                                                }, 0);

                                                                const sumaValoresPregunta = resultado.respuestas.reduce((acc, res) => {
                                                                    return acc + (Number(res.promedio || 0) * Number(res.cantidad || 0));
                                                                }, 0);

                                                                const valorMaximoPregunta = valorMaximo * totalRespuestas;

                                                                const promedioGlobalPorcentaje = valorMaximoPregunta > 0
                                                                    ? (sumaValoresPregunta / valorMaximoPregunta) * 100
                                                                    : 0;

                                                                const promedioGlobal = totalRespuestas > 0
                                                                    ? sumaValoresPregunta / totalRespuestas
                                                                    : 0;

                                                                const promedioGlobalFraccion = `${promedioGlobal.toFixed(2)} / ${valorMaximo}`;

                                                                sumaValoresObtenidos += sumaValoresPregunta;
                                                                sumaValoresMaximos += valorMaximoPregunta;

                                                                return (
                                                                    <div key={index} className="mb-3">
                                                                        <h6>{index + 1}. {resultado.pregunta}</h6>

                                                                        <table className="table table-bordered table-sm">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Opción</th>
                                                                                    <th>Escala (%)</th>
                                                                                    <th>Cantidad de Respuestas</th>
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                {resultado.respuestas.map((respuesta, idx) => {
                                                                                    const promedioPorcentaje = valorMaximo > 0
                                                                                        ? (Number(respuesta.promedio || 0) * 100) / valorMaximo
                                                                                        : 0;

                                                                                    return (
                                                                                        <tr key={idx}>
                                                                                            <td>{respuesta.opcion || 'Sin respuesta'}</td>
                                                                                            <td className="text-center">
                                                                                                {`${Number(promedioPorcentaje).toFixed(2)}%`}
                                                                                            </td>
                                                                                            <td className="text-center">
                                                                                                {Number(respuesta.cantidad || 0)}
                                                                                            </td>
                                                                                        </tr>
                                                                                    );
                                                                                })}
                                                                            </tbody>

                                                                            <tfoot>
                                                                                <tr>
                                                                                    <td colSpan="2" className="text-end">
                                                                                        <strong>Promedio:</strong>
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                        {`${Number(promedioGlobalPorcentaje).toFixed(2)}% (${promedioGlobalFraccion})`}
                                                                                    </td>
                                                                                </tr>
                                                                            </tfoot>
                                                                        </table>
                                                                    </div>
                                                                );
                                                            })}

                                                        {/* Cálculo del promedio general de la evaluación */}
                                                        {this.state.asignaturaSeleccionada && (
                                                            <div className="mt-4">
                                                                <h5 className="text-center">
                                                                    Promedio General de la Evaluación:
                                                                </h5>

                                                                <div className="text-center">
                                                                    <p>
                                                                        Promedio General: {this.state.asignaturaSeleccionada.resultado_global}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                );
                                            })()}

                                            {/* Preguntas abiertas */}
                                            {this.state.resultadosEvaluacion
                                                .filter(resultado => resultado.tipo === 'Abierta')
                                                .map((resultado, index) => {
                                                    const respuestasPorPagina = 5;
                                                    const paginaActual = this.state.paginasPreguntas[resultado.id] || 1;
                                                    const inicio = (paginaActual - 1) * respuestasPorPagina;
                                                    const fin = inicio + respuestasPorPagina;
                                                    const respuestasPaginadas = resultado.respuestas.slice(inicio, fin);
                                                    const totalPaginas = Math.ceil(resultado.respuestas.length / respuestasPorPagina);

                                                    return (
                                                        <div key={resultado.id} className="mb-4">
                                                            <h6>{index + 1}. {resultado.pregunta}</h6>
                                                            {respuestasPaginadas.length > 0 ? (
                                                                <ul className="list-group list-group-flush">
                                                                    {respuestasPaginadas.map((respuesta, idx) => (
                                                                        <li key={idx} className="list-group-item">{respuesta.respuesta}</li>
                                                                    ))}
                                                                </ul>
                                                            ) : (
                                                                <p>No hay respuestas disponibles.</p>
                                                            )}

                                                            {/* Controles de paginación */}
                                                            {totalPaginas > 1 && (
                                                                <div className="mt-2 d-flex justify-content-center">
                                                                    <nav>
                                                                        <ul className="pagination pagination-sm">
                                                                            {Array.from({ length: totalPaginas }, (_, i) => i + 1).map(num => (
                                                                                <li
                                                                                    key={num}
                                                                                    className={`page-item ${paginaActual === num ? 'active' : ''}`}
                                                                                    onClick={() => this.handleCambiarPaginaPregunta(resultado.id, num)}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                >
                                                                                    <span className="page-link">{num}</span>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </nav>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    ) : (
                                        <p>No hay resultados disponibles para esta asignatura.</p>
                                    )
                                )}
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.cerrarModalResultados}>Cerrar</Button>
                            </ModalFooter>
                        </Modal>

                    </div>
                </div>
            </div >
        );
    }
}